import React, {useRef, useState, useEffect} from "react";
import NoDataResponse from "../../../Components/NoDataResponse";
import { BaseUrl } from "../../../Actions/Base";

const InVehicleCompletedLessons = ({ completedClasses, setLiveStream,
  setSavedLocationModal }) => {
  const [activeRow, setActiveRow] = useState(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveRow(null);
      }
    };
  
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex w-full justify-center items-center mt-[40px]">
      <div
        className="w-[90%] rounded-[16px] py-[40px]"
        style={{
          background:
            "transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%)",
          boxShadow: "0px 0px 12px #AEAEFE",
        }}
      >
        <table className="w-full text-left border-collapse">
          
          {/* HEADER */}
          <thead>
            <tr
              className="text-[#FFFFFF] text-[16px]"
              style={{
                background:
                  "linear-gradient(90deg, #B05AC4 0%, #AFABFC 100%)",
              }}
            >
              <th className="text-center py-3 w-[5%]">Class Id</th>
              <th className="text-center py-3 w-[20%]">Student</th>
              <th className="text-center py-3 w-[20%]">Instructor</th>
              <th className="text-center py-3 w-[15%]">Date</th>
              <th className="text-center py-3 w-[15%]">Time</th>
              <th className="text-center py-3 w-[15%]">Status</th>
              <th className="text-center py-3 w-[10%]">Action</th>
            </tr>
          </thead>

          {/* BODY */}
          <tbody>
            {!completedClasses || completedClasses.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center py-10">
                  <NoDataResponse
                    topText="No Completed Lessons"
                    bottomText="Completed lessons will appear here"
                  />
                </td>
              </tr>
            ) : (
              completedClasses.map((row, index) => {
                const isOdd = index % 2 !== 0;

                return (
                  <tr
                    key={row.eventId} // ✅ correct key
                    style={{
                      background: isOdd ? "#F1F1F1" : "#FFFFFF",
                    }}
                  >
                    {/* S.No */}
                    <td className="text-center py-3 text-[#174A84]">
                      {row.classId}
                    </td>

                    {/* Student */}
                    <td className="text-center py-3 text-[#174A84]">
                      <div className="w-full flex justify-center items-center gap-[5px] 2.5xl:gap-[15px]">
                            <div className="w-[50px] h-[50px] rounded-full overflow-hidden">
                                <img
                                className="w-full h-full object-cover"
                                src={`${BaseUrl}/api/images/Student?url=${row.studentAvatar}`}
                                alt="Instructor"
                                />
                            </div>
                            <p className="text-[19px]">{row.studentName || "N/A"}</p>
                        </div>
                    </td>

                    {/* Instructor */}
                    <td className="text-center py-3 text-[#174A84]">
                      
                      <div className="w-full flex justify-center items-center gap-[5px] 2.5xl:gap-[15px]">
                            <div className="w-[50px] h-[50px] rounded-full overflow-hidden">
                                <img
                                className="w-full h-full object-cover"
                                src={`${BaseUrl}/api/images/Instructors?url=${row.instructorAvatar}`}
                                alt="Instructor"
                                />
                            </div>
                            <p className="text-[19px]">{row.instructorName || "N/A"}</p>
                        </div>
                    </td>

                    {/* Date */}
                    <td className="text-center py-3 text-[#174A84]">
                      {row.startTime
                        ? new Date(row.startTime).toLocaleDateString()
                        : "N/A"}
                    </td>

                    {/* Time */}
                    <td className="text-center py-3 text-[#174A84]">
                      {row.startTime
                        ? new Date(row.startTime).toLocaleTimeString()
                        : "N/A"}
                    </td>

                    {/* Status */}
                    <td className="text-center py-3 text-[#174A84]">
                        {row.status || "N/A"}
                    </td>

                    <td className="py-3 text-xl text-[#000000] text-center relative">
  
                      {/* 3 Dots */}
                      <span
                        className="cursor-pointer text-[#174A84]"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveRow(row.eventId);
                        }}
                      >
                        ⋯
                      </span>

                      {/* Dropdown */}
                      {activeRow === row.eventId && (
                        <div
                          ref={dropdownRef}
                          className="absolute top-[40px] right-0 mt-2 w-[140px] bg-white shadow-lg rounded-[8px] z-[999]"
                        >
                          <div className="flex flex-col py-[10px]">

                            {/* PLAY */}
                            <div
                              className="w-full py-2 px-3 text-[14px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                              onClick={() => {
                                if (row.videoUrl) {
                                  window.open(row.videoUrl, "_blank");
                                }
                                setActiveRow(null);
                              }}
                            >
                              Play
                            </div>

                            {/* TRACK */}
                            <div
                              className="w-full py-2 px-3 text-[14px] text-[#174A84] cursor-pointer hover:bg-gradient-to-r hover:from-[#B05AC4] hover:to-[#AFABFC] hover:text-white"
                              onClick={() => {
                                if (row?.locationKey) {
                                  setSavedLocationModal(row.locationKey); // ✅ same as your commented logic
                                }
                                setLiveStream(row.videoUrl); // optional (same behavior as before)
                                setActiveRow(null);
                              }}
                            >
                               Track
                            </div>

                          </div>
                        </div>
                      )}
                    </td>

                    {/* Recording */}
                    {/* <td className="text-center py-3">
                      {row.videoUrl ? (
                        <a
                          href={row.videoUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="text-blue-600 underline"
                        >
                          Play
                        </a>
                      ) : (
                        <span className="text-gray-400">
                          No Recording
                        </span>
                      )}
                    </td> */}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InVehicleCompletedLessons;